import React from 'react';
import { Box, Skeleton } from '@mui/material';

const HeaderSkeleton: React.FC = () => {
  return (
    <Box
      sx={{
        width: '100%',
        height: '64px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '0 16px',
        backgroundColor: '#fff',
        borderBottom: '1px solid #eaeaea'
      }}
    >
      <Skeleton 
        variant="rectangular" 
        width={120} 
        height={24} 
        sx={{ borderRadius: 1 }}
      />

      <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
        <Skeleton variant="circular" width={32} height={32} />
        <Skeleton variant="circular" width={32} height={32} />
        <Skeleton variant="circular" width={40} height={40} />
      </Box>
    </Box>
  );
};

export default HeaderSkeleton;